import { Reducer } from "react";
import { IShow } from "@evennt-tech/api-v2-core";

export type SortBy = keyof Pick<IShow, "liveStart" | "name">;
export type SortOrder = "asc" | "desc";
export enum ActionType {
  SET_SEARCH_QUERY = "SET_SEARCH_QUERY",
  SET_SORT_SETTING = "SET_SORT_SETTING",
  RESET_FILTERS = "RESET_FILTERS",
}
export type SortOption = {
  label: string;
  value: { sortBy: SortBy; sortOrder: SortOrder };
};
export const sortOptions: SortOption[] = [
  {
    label: "Date",
    value: { sortBy: "liveStart", sortOrder: "asc" },
  },
  {
    label: "Name A-Z",
    value: { sortBy: "name", sortOrder: "asc" },
  },
  {
    label: "Name Z-A",
    value: { sortBy: "name", sortOrder: "desc" },
  },
];
export const getSortLabel = (value: SortOption["value"]) =>
  sortOptions.find(
    (option) =>
      option.value.sortBy === value.sortBy &&
      option.value.sortOrder === value.sortOrder
  )?.label;
export type FilterAction =
  | { type: ActionType.SET_SEARCH_QUERY; payload: string }
  | { type: ActionType.SET_SORT_SETTING; payload: SortOption["value"] }
  | { type: ActionType.RESET_FILTERS };

export type FilterState = {
  sortBy: SortBy;
  sortOrder: SortOrder;
  query: string;
};

export const initialState: FilterState = {
  sortBy: "liveStart",
  query: "",
  sortOrder: "asc",
};
const filterReducer: Reducer<FilterState, FilterAction> = (
  state: FilterState,
  action: FilterAction
) => {
  switch (action.type) {
    case ActionType.SET_SEARCH_QUERY:
      return { ...state, query: action.payload };
    case ActionType.SET_SORT_SETTING:
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };
    case ActionType.RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
export default filterReducer;
